<template>
  <div class="uds-bonuses">
    <v-tabs v-model="currentTab">
      <v-tab :key="'code'" @click="currentMethod = 'code'">
        <span class="uds-bonuses_tab-icon">
          <icon-qr class="ui-icon" />
        </span>
        По коду
      </v-tab>
      <v-tab :key="'phone'" @click="currentMethod = 'phone'">
        <span class="uds-bonuses_tab-icon">
          <icon-phone class="ui-icon" />
        </span>
        По телефону
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentTab">
      <v-tab-item
        :key="'code'"
      >
        <v-form
          ref="code"
          class="uds-bonuses_tab-content"
          @submit="(e) => {
            e.preventDefault()
            this.apply()
          }"
        >
          <span class="uds-bonuses_tab-text">Для списания бонусов введите код </span>
          <ui-field label="Для списания бонусов введите код">
            <v-text-field
              solo
              class="ui-input"
              label="Код"
              v-model="codeValue"
              v-mask="'### ###'"
              :rules="[validationRules.required, validationRules.code]"
              hide-details="auto"
              :error-messages="codeErrorMessage"
            />
          </ui-field>
        </v-form>
      </v-tab-item>

      <v-tab-item
        :key="'phone'"
      >
        <v-form
          ref="phone"
          class="uds-bonuses_tab-content"
          @submit="(e) => {
            e.preventDefault()
            this.apply()
          }"
        >
          <span class="uds-bonuses_tab-text">Для начисления бонусов введите телефон</span>
          <ui-field label="Для начисления бонусов введите телефон">
            <v-combobox
              solo
              class="ui-input uds-bonuses_phone-field"
              label="Телефон"

              :items="guestsPhones"
              :search-input.sync="phoneValue"
              v-mask="'+7 (###) ###-##-##'"
              :rules="[validationRules.required, validationRules.tel]"
              hide-details="auto"
              :error-messages="phoneErrorMessage"
            />
          </ui-field>
        </v-form>
      </v-tab-item>
    </v-tabs-items>

    <div class="uds-bonuses_actions">
      <a
        href="javascript:void(0)"
        class="uds-bonuses_action ui-btn"
        @click="apply"
      >
        Ввод
      </a>
      <a href="javascript:void(0)" class="uds-bonuses_action ui-btn ui-btn--grey" @click="closeDialog">Отмена</a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'uds-bonuses',

  data: () => ({
    currentTab: 0,
    currentMethod: 'code',
    codeValue: null,
    phoneValue: null,
    validationRules: {
      required: value => !!value || 'Обязательно к заполнению.',
      code: value => {
        const pattern = /^\d{3}\s{1}\d{3}$/
        return pattern.test(value) || 'Неверный формат кода.'
      },
      tel: value => {
        const pattern = /^\+7\s{1}\(\d{3}\)\s{1}\d{3}\-\d{2}\-\d{2}$/
        return pattern.test(value) || 'Неверный формат номера телефона.'
      },
    },

    codeErrorMessage: ``,
    phoneErrorMessage: ``,
  }),

  methods: {
    ...mapMutations({
      setIsLoading: 'setIsLoading',
    }),

    ...mapActions({
      updateBonusProgram: 'loyalty/updateBonusProgram',
      updateSavedBookingInfo: 'selection/updateSavedBookingInfo',
    }),

    closeDialog() {
      this.currentTab = 0
      this.currentMethod = 'code'
      this.codeValue = null
      this.phoneValue = null
      this.$emit('dialogClose')
    },

    async apply() {
      this.setIsLoading(true)
      const udsPayload = {
        total: this.savedBookingInfo.ticketPrice,
        primaryPrice: this.savedBookingInfo.primaryPrice,
        rsvPersonId: this.savedBookingInfo.rsvPersonId,
        dealId: this.savedBookingInfo.dealId,
      }
      if(this.currentMethod === 'code') {
        if(!this.$refs.code.validate()) return
        udsPayload.code = this.codeValue.replace(/\s+/g, '')
      } else if(this.currentMethod === 'phone') {
        if(!this.$refs.phone.validate()) return
        udsPayload.phone = this.phoneValue.replace(/[\(\)\-\s]/g, '')
      }
      const udsFullResponse = await this.udsRequest(udsPayload),
        udsResp = udsFullResponse.data

      /* обработка ошибок начало */
      if(udsResp.status === `ERROR` || udsFullResponse.status === 'error') {
        this.codeErrorMessage = `Произошла ошибка. Попробуйте позже.`
        this.phoneErrorMessage = `Произошла ошибка. Попробуйте позже.`
        this.setIsLoading(false)
        return
      }
      if (udsResp.result === 'error' && udsResp.type === 'certificate') {
        this.codeErrorMessage = this.phoneErrorMessage = `Применение сертификата запрещено, обратитесь в Отдел реализации путевок: +7 (342) 2 500 700.`
        this.setIsLoading(false)
        return
      }
      if(this.currentMethod === 'code') {
        if(!udsResp.code) {
          this.codeErrorMessage = `Неверный код`
          this.setIsLoading(false)
          return
        }
        if(+udsResp.canWrite === 0 && +udsResp.totalPoints > 0) {
          this.codeErrorMessage = `Обновите код`
          this.setIsLoading(false)
          return
        }
        if(+udsResp.canWrite === 0 && +udsResp.totalPoints === 0) {
          this.codeErrorMessage = `Нет доступных для списания бонусов`
          this.setIsLoading(false)
          return
        }
      }
      if(this.currentMethod === 'phone' && udsResp.phone === null) {
        this.phoneErrorMessage = `Номер не зарегистрирован в программе UDS`
        this.setIsLoading(false)
        return
      }
      /* обработка ошибок конец */

      this.updateBonusProgram({
        id: 'uds',
        data: {
          isApplied: true,
          data: {
            code: udsResp.code,
            totalSum: udsResp.cash + udsResp.canWrite,
            canWrite: udsResp.canWrite,
            cashBack: udsResp.cashBack,
            cash: udsResp.cash,
            phone: udsResp.phone,
          },
        },
      })

      /* points start */
      const pointsPayload = this.getPointsPayload()
      const pointsResp = await this.pointsRequest(pointsPayload)
      if(pointsResp) {
        let obj = {
          paymentPrice: pointsResp.price,
          sbp: {...this.savedBookingInfo.sbp, ...pointsResp.sbp, extraServices: this.savedBookingInfo?.sbp?.extraServices},
          loyaltyPointsUds: pointsResp.loyaltyPointsUds,
        }
        this.updateSavedBookingInfo(obj)
      }
      /* points end */

      this.setIsLoading(false)
      this.closeDialog()
    },

    async udsRequest(payload) {
      try {
        let resp = await this.$http.post(`/deal/${payload.dealId}/getUdsInfo/`, payload) // solar:booking.api.uds
        return resp.data
      } catch (e) {
        console.error(e)
        return false
      }
    },

    getPointsPayload() {
      return {
        clusterId: this.savedBookingInfo.clusterId,
        rsvPersonId: this.savedBookingInfo.rsvPersonId,
        requestId: this.savedBookingInfo.requestId,
        loyaltyPoints: this.getUdsData.canWrite || 0,
        price: this.savedBookingInfo.price,
        primaryPrice: this.savedBookingInfo.primaryPrice,
        sbp: this.savedBookingInfo.sbp,
        ticketPrice: this.savedBookingInfo.ticketPrice,
        isPaid: false,
      }
    },

    async pointsRequest(payload) {
      try {
        let resp = await this.$http.post(`/payment/sbp/generatePoints/`, payload) // solar:booking.api.points
        return resp.data.data
      } catch(e) {
        console.error(e)
        return false
      }
    },
  },

  computed: {
    ...mapState({
      savedBookingInfo: state => state.selection.savedBookingInfo,
    }),
    ...mapGetters({
      getGuestsFields: 'guestsModule/getGuestsFields',
      totalPrice: 'getPriceForUDS',
      getUdsData: 'loyalty/getUdsData',
    }),

    guestsPhones() {
      return this.getGuestsFields(['phone']).map(obj => obj.phone)
    },
  },

  watch: {
    phoneValue(v) {
      this.phoneErrorMessage = ``
    },

    codeValue(v) {
      this.codeErrorMessage = ``
    },

    currentTab() {
      this.phoneValue = null
      this.codeValue = null
      this.codeErrorMessage = ``
      this.phoneErrorMessage = ``
    },

    phoneValue(v) {
      if(v.length < 6 && v[4] === '8') {
        this.$nextTick(() => this.phoneValue = '+7 (')
      }
    }
  }
}
</script>

<style lang="sass">
.uds-bonuses
  width: 100%

.uds-bonuses_tab-icon
  margin-right: px-em(10)

.uds-bonuses_actions
  width: 100%
  display: flex
  align-items: center
  justify-content: center
  margin-top: px-em(40)

.uds-bonuses_action

  + .uds-bonuses_action
    margin-left: px-em(12)

.uds-bonuses_tab-content
  padding: px-em(40) 0 0

.uds-bonuses_tab-text
  display: block
  margin-bottom: px-em(20)
  color: #1A4745

.uds-bonuses_phone-field
  .v-input__append-inner > .v-input__icon--append
    cursor: pointer

@media screen and (max-width: $mobile-breakpoint)
  .uds-bonuses_tab-content
    padding-top: px-em(20,12)

  .uds-bonuses_actions
    margin-top: px-em(10,12)
    flex-direction: column

  .uds-bonuses_action
    width: 100%

    + .uds-bonuses_action
      margin-left: 0
      margin-top: px-em(10,12)

</style>
